import React, { Component } from "react";
import Layout from "../../Layout/layout";
import Helmet from "react-helmet";
import "../../styles/profile/profile.scss";
import { Form, Button, Modal } from "react-bootstrap";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { apiHost } from "../../api/apiClient";
import axios from "axios";

class ManageAccount extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    errors: {},
    message: "",
    requestError: "",
    confirmationOpen: false,
    saving: false,
  };

  updateField = (field) => (event) => {
    this.setState({
      [field]: event.target.value,
      errors: { ...this.state.errors, [field]: "", passwordMatch: "" },
      message: "",
      requestError: "",
    });
  };

  validate = () => {
    const { oldPassword, newPassword, confirmPassword } = this.state;
    const errors = {};

    if (!oldPassword) errors.oldPassword = "Enter your current password.";
    if (!newPassword) errors.newPassword = "Enter a new password.";
    else if (newPassword.length < 6 || newPassword.length > 20) errors.newPassword = "Use between 6 and 20 characters.";
    if (!confirmPassword) errors.confirmPassword = "Confirm your new password.";
    else if (newPassword !== confirmPassword) errors.passwordMatch = "The new passwords do not match.";
    if (oldPassword && newPassword && oldPassword === newPassword) errors.newPassword = "Choose a password different from your current password.";

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  requestConfirmation = (event) => {
    event.preventDefault();
    if (this.validate()) this.setState({ confirmationOpen: true });
  };

  handlePasswordChange = async () => {
    this.setState({ confirmationOpen: false, saving: true, message: "", requestError: "" });
    this.props.setLoadingPageAction(true);

    try {
      await axios.post(
        `${apiHost}/api/Auth/ResetPassword`,
        { CurrentPassword: this.state.oldPassword, NewPassword: this.state.newPassword },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      this.setState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        errors: {},
        message: "Your password has been changed successfully.",
        saving: false,
      });
    } catch (error) {
      if (error.response?.status === 401) {
        this.props.history.push("/login");
      } else {
        const requestError = error.response?.data || "Your password could not be changed. Check your current password and try again.";
        this.setState({ requestError: String(requestError), saving: false });
      }
    } finally {
      this.props.setLoadingPageAction(false);
    }
  };

  render() {
    const { oldPassword, newPassword, confirmPassword, errors, message, requestError, confirmationOpen, saving } = this.state;
    return (
      <Layout>
        <Helmet><title>Change Password | VisionTrak</title></Helmet>
        <main className="account-security-page">
          <section className="account-security-card">
            <header className="account-security-header">
              <span className="account-security-icon"><i className="fa fa-lock" aria-hidden="true"></i></span>
              <div><span>Account security</span><h1>Change Password</h1><p>Update the password used to sign in to your VisionTrak account.</p></div>
            </header>

            {message && <div className="account-security-message success" role="status"><i className="fa fa-check-circle"></i><div><strong>Password updated</strong><span>{message}</span></div></div>}
            {requestError && <div className="account-security-message error" role="alert"><i className="fa fa-exclamation-circle"></i><div><strong>Password not changed</strong><span>{requestError}</span></div></div>}

            <Form className="account-security-form" onSubmit={this.requestConfirmation} noValidate>
              <Form.Group controlId="current-password">
                <Form.Label>Current password</Form.Label>
                <Form.Control type="password" autoComplete="current-password" value={oldPassword} onChange={this.updateField("oldPassword")} isInvalid={Boolean(errors.oldPassword)} />
                <Form.Control.Feedback type="invalid">{errors.oldPassword}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="new-password">
                <Form.Label>New password</Form.Label>
                <Form.Control type="password" autoComplete="new-password" value={newPassword} onChange={this.updateField("newPassword")} isInvalid={Boolean(errors.newPassword)} />
                <Form.Text>Use between 6 and 20 characters.</Form.Text>
                <Form.Control.Feedback type="invalid">{errors.newPassword}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="confirm-password">
                <Form.Label>Confirm new password</Form.Label>
                <Form.Control type="password" autoComplete="new-password" value={confirmPassword} onChange={this.updateField("confirmPassword")} isInvalid={Boolean(errors.confirmPassword || errors.passwordMatch)} />
                <Form.Control.Feedback type="invalid">{errors.confirmPassword || errors.passwordMatch}</Form.Control.Feedback>
              </Form.Group>
              <Button type="submit" className="account-security-submit" disabled={saving}><i className="fa fa-shield"></i> Update password</Button>
            </Form>
          </section>
        </main>

        <Modal show={confirmationOpen} onHide={() => this.setState({ confirmationOpen: false })} centered className="password-confirmation-modal">
          <Modal.Header closeButton><Modal.Title>Confirm password update</Modal.Title></Modal.Header>
          <Modal.Body><div className="password-confirmation-copy"><span><i className="fa fa-lock"></i></span><div><strong>Are you sure you want to update your password?</strong><p>You’ll use the new password the next time you sign in.</p></div></div></Modal.Body>
          <Modal.Footer><Button variant="outline-secondary" onClick={() => this.setState({ confirmationOpen: false })}>Cancel</Button><Button variant="primary" onClick={this.handlePasswordChange} disabled={saving}>Yes, update password</Button></Modal.Footer>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({ loading: state.loading });
const mapDispatchToProps = { setLoadingPageAction: setLoadingPage, setErrorMessageAction: setErrorMessage };

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccount);
